import { authenticationService } from "@/services/api_functions";

export function authHeader() {
  const token = localStorage.getItem("authenticationService");
  return {
    // "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export function authLogin() {
  return {
    "Content-Type": "application/json",
  };
}

export function getHeader() {
  const token = localStorage.getItem("authenticationService");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

 
